// eslint ignore
/* global EVENT_FETCH_COUNT: true */
/* global BETA_MODE: true */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';
import { Redirect } from 'react-router-dom';

import HomePage from './HomePage';
import QueryHandler from '../components/misc/QueryHandler';
import { HOME_PAGE_IMAGES } from '../utils/variables';

////////////////////////////////////////////
// TODO MISSING TESTS
////////////////////////////////////////////

class HomePageQueryRenderer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // For various reasons, the home page of the new website
    // will not be shown. Everytime the user should see the "new"
    // home page, he will be redirected to the SG legacy page.
    // `BETA_MODE` is defined in `webpack.common.js`
    if (BETA_MODE) {
      if (window.location.href.includes('beta.sportograf.com')) {
        window.location.replace(
          `https://www.sportograf.com/${this.props.match.params.language}/shop`,
        );
        return null;
      }
    }

    // to avoid rendering sportograf.com/en/home_page
    if (this.props.match.params.landingpage === HOME_PAGE_IMAGES) {
      return <Redirect to={`/`}/>
    }

    return (
      <div className="main-page-container">
        <QueryHandler
          hasLoadingBackground={true}
          query={graphql`
            query HomePageQueryRendererQuery(
              $count: Int!
              $cursor: String
              $query: String
              $landingpage: String
              $noLandingpage: Boolean
            ) {
              viewer(landingpage: $landingpage) {
                ...HomePage_viewer
              }
            }
          `}
          // `EVENT_FETCH_COUNT` is defined in `webpack.common.js`
          variables={{
            count: EVENT_FETCH_COUNT,
            landingpage: this.props.match.params.landingpage || HOME_PAGE_IMAGES,
            noLandingpage: this.props.match.params.landingpage === undefined || this.props.match.params.landingpage === HOME_PAGE_IMAGES,
          }}
          render={props => {
            return <HomePage viewer={props.viewer} />;
          }}
        />
      </div>
    );
  }
}

HomePageQueryRenderer.propTypes = {
  match: PropTypes.object,
};

export default HomePageQueryRenderer;
